import * as React from 'react';
import { createContext } from 'react';

export const context = createContext<AccountContext>({} as AccountContext);

export const { Provider } = context;
